module.exports = __webpack_public_path__ + "img/hurricane-02.2d6eb1e1.svg";